import { useState, useEffect, useContext } from 'react';
import { useRouter } from 'next/router';
import { useForm } from 'react-hook-form';
import { firestore } from '../../lib/firebase';
import Navbar from '../../components/Navbar3';
import FormNavigation from '../../components/birth-control/FormNavigation';
import styles from '../../styles/Birth.module.css';
import { UserContext } from '../../lib/context';
import createNewConsult from '../../lib/helper/createNewConsult';
import { setCookie, getCookie } from 'cookies-next';

export default function Profile() {
  const router = useRouter();
  const { user, userData } = useContext(UserContext);
  const [isLoading, setIsLoading] = useState(false);
  const [progress, setProgress] = useState(null);
  const [width, setWidth] = useState(null);
  const totalSteps = 1;
  const [step, setStep] = useState(1);

  useEffect(() => {
    console.log(user);
  }, [user]);

  useEffect(() => {
    setProgress(step / totalSteps);
    setWidth(window.innerWidth);
  }, [step]);

  // Check if UTM parameters and put them in the cookies
  useEffect(() => {
    if (router) {
      let pars = [];
      // Only if no user logged in
      // Get the utm params if the exists and put in an array of objects
      if (!user) {
        let utms = router.asPath.split('?')[1];
        if (utms) {
          utms = utms
            .split('&')
            .filter(
              (utm) =>
                utm.includes('utm_source') ||
                utm.includes('utm_campaign') ||
                utm.includes('utm_term')
            );
          pars = utms.map((utm, i) => {
            return { param: utm.split('=')[0], value: utm.split('=')[1] };
          });
        }
      }

      // Put it in the cookies
      if (pars.length > 0) {
        pars.forEach((param) => {
          setCookie(param.param, param.value, {
            maxAge: 60 * 60 * 24 * 30 * 12,
          });
          console.log(param);
        });
      }
    }
  }, [router]);

  const start = async () => {
    if (!user) {
      router.push('/birth-control/register');
    } else if (user) {
      console.log(userData);
      if (
        userData?.pronoun &&
        userData?.sex &&
        userData?.dateOfBirth &&
        userData?.province
      ) {
        await createNewConsult(user, router);
      } else {
        router.push('/birth-control/profile');
      }
    } else {
      router.push('/birth-control/profile');
    }
  };

  return (
    <>
      <Navbar />
      <Progress2 progress={progress} width={width} />
      <div className={`${styles['body-container2']} red`}>
        <div className={`${styles['page-container']} red`}>
          <div className={`${styles['title-container']} red`}>
            <div className={`${styles['page-title']} red`}>
              Let&apos;s get started!
            </div>
          </div>
          <button
            className={`${styles['bottom-btn-next2']} red`}
            onClick={start}
            // disabled={isLoading}
          >
            Start
          </button>
        </div>
      </div>
    </>
  );
}

// ----------------
// Other Components
// ----------------

// Progress Bar
function Progress({ progress, width }) {
  return (
    <div className={`${styles['progress-container']} red`}>
      <div
        className={`${styles['progress-progress']} red`}
        // style={{ width: window.innerWidth * progress }}
        style={{ width: width * progress }}
      />
    </div>
  );
}

// Progress Bar 2
function Progress2({ progress, width }) {
  return (
    <div className={`${styles['progress-container2']} red`}>
      <div
        className={`${styles['progress-progress2']} red`}
        // style={{ width: window.innerWidth * progress }}
        style={{ width: width * progress }}
      />
    </div>
  );
}
